import checkFitment from '../../graphql/products/checkFitment'
import getFreeShippingAndAvailability from '../../graphql/products/getFreeShippingAndAvailability'
import selectKitComponentIndexOption from '../../graphql/products/selectKitComponentIndexOption'
import submitAnswer from '../../graphql/products/submitAnswer'
import submitQuestion from '../../graphql/products/submitQuestion'

import GraphQLRequest from 'Clutch/Utilities/GraphQLClient/GraphQLClient'

export async function bustStaticPage(productPageId, sku, webUserGuid) {
  const variables = {
    productPageId: parseInt(productPageId),
    skuVariant: sku,
    webUserGuid: webUserGuid,
  }

  // Persisted query that gets a whole lot of product page data. We should change the name of this
  // to not be a hash and rather something like "GetAllPDPData"
  try {
    const res = await GraphQLRequest('/graphql/products', '4aafdb314634abcb4b726ffa45c8d1d6', variables)
    return res?.productPage ?? null
  } catch (error) {
    console.error('Failed bustStaticPage', error)
    return null
  }
}

export async function onIndexOptionSelection(
  productPageId,
  sku,
  selectedIndexOptions,
  mostRecentlySelectedIndexOption,
  webUserGuid,
) {
  const completeSelectedIndexOptions = selectedIndexOptions
    ? selectedIndexOptions.concat([mostRecentlySelectedIndexOption])
    : [mostRecentlySelectedIndexOption]

  const variables = {
    productPageId: parseInt(productPageId),
    skuVariant: sku,
    selectedIndexOptions: completeSelectedIndexOptions.map((value) => parseInt(value)),
    lastSelectedOption: parseInt(mostRecentlySelectedIndexOption),
    webUserGuid: webUserGuid,
  }

  //persisted query
  try {
    const res = await GraphQLRequest('/graphql/products', '4aafdb314634abcb4b726ffa45c8d1d6', variables)
    return res?.productPage ?? null
  } catch (error) {
    console.error('Failed onIndexOptionSelection', error)
    return null
  }
}

export async function onKitComponentIndexOptionSelection(
  skuBase,
  skuVariant,
  selectedIndexOptions,
  mostRecentlySelectedIndexOption,
) {
  const completeSelectedIndexOptions = selectedIndexOptions
    ? selectedIndexOptions.concat([mostRecentlySelectedIndexOption])
    : [mostRecentlySelectedIndexOption]

  const variables = {
    skuBase: skuBase,
    skuVariant: skuVariant,
    selectedIndexOptions: completeSelectedIndexOptions.map((value) => parseInt(value)),
    lastSelectedOption: parseInt(mostRecentlySelectedIndexOption),
  }

  const res = await GraphQLRequest('/graphql/products', selectKitComponentIndexOption, variables)
  return res
}

export async function loadFreeShippingAndAvailability(productPageId, skuVariant) {
  const variables = {
    request: {
      productPageId: parseInt(productPageId),
      skuVariant: skuVariant,
    },
  }

  const res = await GraphQLRequest('/graphql/products', getFreeShippingAndAvailability, variables)
  return res
}

export async function checkFitmentNew(skuBase, skuVariant, checkFitmentRequest) {
  const variables = {
    skuBase: skuBase,
    skuVariant: skuVariant,
    checkFitmentRequest,
  }

  const res = await GraphQLRequest('/graphql/products', checkFitment, variables)
  return res
}

export async function submitAQuestion(skuNum, questionText, nickName, email, location) {
  const variables = {
    pageId: skuNum,
    questionText,
    authorName: nickName,
    email,
    authorLocation: location,
  }

  try {
    const res = await GraphQLRequest('/graphql/products', submitQuestion, variables)
    return res?.productPage ?? null
  } catch (error) {
    console.error('Failed submitQuestion', error)
    return null
  }
}

export async function submitAnAnswer(skuNum, questionId, answerText, nickName, email, location) {
  const variables = {
    pageId: skuNum,
    questionId,
    answerText,
    authorName: nickName,
    email,
    authorLocation: location,
  }

  try {
    const res = await GraphQLRequest('/graphql/products', submitAnswer, variables)
    return res?.productPage ?? null
  } catch (error) {
    console.error('Failed submitAnswer', error)
    return null
  }
}
